export default __webpack_public_path__ + "static/media/howt0_2.338c0faa.png";